import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'
import { BRAND_MINT } from '@/lib/utils'
import { cn } from '@/lib/utils'
import { CreditCardIcon, FileTextIcon, BuildingIcon, ChevronLeftIcon, PlusCircleIcon } from 'lucide-react'

const billingTabs = [
  { to: '/dashboard/billing', label: 'Overview', icon: CreditCardIcon, exact: true },
  { to: '/dashboard/billing/invoices', label: 'Invoices', icon: FileTextIcon, exact: false },
  { to: '/dashboard/billing/add-ons', label: 'Add-ons', icon: PlusCircleIcon, exact: false },
  { to: '/dashboard/billing/bank-details', label: 'Bank details', icon: BuildingIcon, exact: false },
]

export const Route = createFileRoute('/dashboard/billing')({
  component: () => {
    const routerState = useRouterState()
    const currentPath = routerState.location.pathname

    return (
      <div className="mx-auto max-w-4xl">
        <div className="mb-6">
          <Link to="/dashboard" className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors">
            <ChevronLeftIcon className="size-3" />Back to dashboard
          </Link>
        </div>

        {/* Tab navigation */}
        <div className="mb-6 flex gap-1 rounded-lg border border-border bg-card p-1 overflow-x-auto">
          {billingTabs.map((tab) => {
            const isActive = tab.exact
              ? currentPath === tab.to
              : currentPath.startsWith(tab.to) && tab.to !== '/dashboard/billing'
            return (
              <Link
                key={tab.to}
                to={tab.to}
                className={cn(
                  'flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-colors whitespace-nowrap',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground',
                )}
              >
                <tab.icon className="size-3.5" />
                {tab.label}
              </Link>
            )
          })}
        </div>

        <Outlet />
      </div>
    )
  },
})
